import { ReactNode, lazy } from "react";

// Icons Import 

import { Home } from "react-feather";
import { AiFillQuestionCircle, AiFillStar} from "react-icons/ai"
import {FaUserFriends , FaUser, FaHome, FaSadCry, FaProductHunt, FaBorderAll, FaAdversal } from "react-icons/fa"
import { MdOutlineCategory, MdPrivacyTip, MdProductionQuantityLimits } from "react-icons/md";
import {DiDatabase} from "react-icons/di"
import { FiMail } from "react-icons/fi";
import {CgUnavailable} from "react-icons/cg"
import {BsCode, BsInfoCircle} from "react-icons/bs"
import {AiOutlineTransaction ,AiFillSetting ,AiFillGift} from "react-icons/ai"
import { IoIosNotificationsOutline, IoIosPaper, } from "react-icons/io";
import { BiCategory, BiLockAlt } from "react-icons/bi";
import { RiCouponFill } from "react-icons/ri";
import { IoPersonAddSharp } from "react-icons/io5";
import { MdOutlineManageAccounts } from "react-icons/md";
import { TbBrandSocketIo } from "react-icons/tb";
import { BsPersonFillAdd } from "react-icons/bs";
import { FaMessage } from "react-icons/fa6";
import { TfiLayoutSlider } from "react-icons/tfi";
import { GrServices } from "react-icons/gr";
import { VscProject } from "react-icons/vsc";
import { GiNetworkBars } from "react-icons/gi";

// Pages Import

import ServicesPage from "./Pages/Services/ServicesPage";
import SocialMediaPage from "./Pages/SocialMedia/SocialMediaPage";
import StaticInfoPage from "./Pages/StaticInfo/StaticInfoPage";
import ProjectsPage from "./Pages/projects/ProjectsPage";
import WorksPage from "./Pages/works/WorksPage";
import RecentWorksPage from "./Pages/RecentWorks/RecentWorksPage";
import ContactPage from "./Pages/Contact/ContactPage";

interface RoutesLinksType {
    name?: string,
    href?: string,
    element?: ReactNode,
    icon?: any,
    Viewelement?: ReactNode,
    Viewhref?: string
    children?: any
    // Hidden the route from the navigation sidebar
    hidden?: boolean 
}
export const RoutesLinks: RoutesLinksType[] = [

   
    {
        name: "Services",  
        element: <ServicesPage />, 
        icon: <GrServices />, 
        href: "/", 
    },
    {
        name: "Social Media",  
        element: <SocialMediaPage />, 
        icon: <FiMail />, 
        href: "/social_media", 
    },
    {
        name: "Static Info",  
        element: <StaticInfoPage />, 
        icon: <BsInfoCircle />, 
        href: "/static_info", 
    },
    {
        name: "Works",  
        element: <WorksPage />, 
        icon: <BiCategory />, 
        href: "/works", 
    },
    {
        name: "Projects",  
        element: <ProjectsPage />, 
        icon: <VscProject />, 
        href: "/projects", 
    },
    {
        name: "Recent Wokrs",  
        element: <RecentWorksPage />, 
        icon: <GiNetworkBars />, 
        href: "/recent_works", 
    },
    {
        name: "contact",  
        element: <ContactPage />, 
        icon: <FaMessage />, 
        href: "/contact", 
    }

]

/// 
// image must be image error service
// connect with website //1 hour
